export const ABOUT_US = {
  heading: "About Honeywell Digital Prime Twin",
  version: "Version R120.1 Update1",
  pat: "Pat.: honpat.com",
  copyright:
    "Copyright 2025, Honeywell International Inc., All rights reserved",
  end_user: "End User License Agreement",
};
